import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260519_disable_generate_roof_framing",
  description:
    "Disable persisted roof framing generation settings. Need this because I am removing enabledFeatures.roofFraming gate for tests to run. Considering no user is using this feature it is safe to disable it for models which had it enabled.",
  apply(json: any) {
    for (const settingsId in json.settings ?? {}) {
      const settings = json.settings[settingsId];
      if (settings.type === "ROOF_SETTINGS" && settings.generateRoofFraming === true) {
        settings.generateRoofFraming = false;
      }
    }

    for (const roofId in json.roofs ?? {}) {
      const roofSettings = json.roofs[roofId].roofSettings;
      if (roofSettings?.generateRoofFraming === true) {
        roofSettings.generateRoofFraming = false;
      }
    }

    return json;
  },
};

export default migration;
